import React, { useState } from 'react';
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import AirwallexForm from './AirwallexForm';

// O Stripe trata de tudo: cartão (com 3DS quando necessário) e Multibanco
// (voucher hospedado pelo Stripe). Nós só confirmamos e apontamos o return_url.
function PayForm({ token, value, returnUrl }) {
  const stripe = useStripe();
  const elements = useElements();

  const [isPaying, setIsPaying] = useState(false);
  const [payError, setPayError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setIsPaying(true);
    setPayError('');

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // WooCommerce: página "order received" da loja; bot: a nossa /success
        return_url: returnUrl || `${window.location.origin}${process.env.PUBLIC_URL}/success/${token}`,
      },
    });

    // Só chegamos aqui se a confirmação falhar (sucesso segue o fluxo do Stripe)
    if (error) {
      setPayError(
        error.type === 'card_error' || error.type === 'validation_error'
          ? error.message
          : 'Não foi possível concluir o pagamento, tente mais tarde.'
      );
    }

    setIsPaying(false);
  };

  return (
    <form onSubmit={handleSubmit} className="payForm">
      <PaymentElement
        options={{
          layout: {
            type: 'accordion',
            radios: true,
            spacedAccordionItems: true,
          },
          // Cartão primeiro e selecionado por defeito
          paymentMethodOrder: ['card', 'multibanco'],
        }}
      />

      {payError && <div className="error">{payError}</div>}

      <button
        type="submit"
        className="payButton"
        disabled={isPaying || !stripe || !elements}
      >
        {isPaying ? 'A processar...' : `Pagar ${Number(value).toFixed(2)} EUR`}
      </button>
    </form>
  );
}

// A moldura (resumo à esquerda, pagamento à direita) é a mesma para todos os
// processadores. Só o widget de pagamento é que muda: Elements do Stripe, ou
// Drop-in da Airwallex.
export default function CheckoutForm({
  provider = 'stripe',
  stripePromise,
  publishableKey,
  intentId,
  clientSecret,
  token,
  value,
  email,
  fullName,
  username,
  packageName,
  returnUrl,
}) {
  return (
    <div className="checkoutPage">
      <div className="checkoutSummary">
        <div className="checkoutSummaryInner">
          <div className="checkoutBrand">Secure Checkout</div>

          <p className="checkoutLabel">Pagamento</p>
          <p className="checkoutAmount">
            {Number(value).toFixed(2)} <span>EUR</span>
          </p>

          <div className="checkoutInfo">
            {username && (
              <div className="checkoutInfoRow">
                <span>Conta</span>
                <strong>{username}</strong>
              </div>
            )}
            {packageName && (
              <div className="checkoutInfoRow">
                <span>Descrição</span>
                <strong>{packageName}</strong>
              </div>
            )}
            {fullName && (
              <div className="checkoutInfoRow">
                <span>Nome</span>
                <strong>{fullName}</strong>
              </div>
            )}
            {email && (
              <div className="checkoutInfoRow">
                <span>Email</span>
                <strong>{email}</strong>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="checkoutDetails">
        <div className="checkoutDetailsInner">
          <h2 className="checkoutTitle">Detalhes de pagamento</h2>
          <p className="checkoutSubtitle">
            Escolha um método de pagamento para concluir a renovação.
          </p>

          {provider === 'airwallex' ? (
            <AirwallexForm
              env={publishableKey}
              intentId={intentId}
              clientSecret={clientSecret}
              currency="EUR"
              returnUrl={returnUrl || `${window.location.origin}${process.env.PUBLIC_URL}/success/${token}`}
            />
          ) : (
            <Elements
              stripe={stripePromise}
              options={{
                clientSecret,
                locale: 'pt',
                appearance: {
                  theme: 'stripe',
                  variables: { colorPrimary: '#171e2e' },
                },
              }}
            >
              <PayForm token={token} value={value} returnUrl={returnUrl} />
            </Elements>
          )}
        </div>
      </div>
    </div>
  );
}
